import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/internal-execution/page.tsx");
